import React from "react"
import Seo from "../seo"

/**
 * SEO Block component for Storyblok
 * This component doesn't render anything visible, but provides SEO data
 * It should be placed at the top of a page's body content in Storyblok
 */
const SeoBlock = ({ blok }) => {
	// This component doesn't render anything visible
	// The SEO data is extracted in the page template
	return null
}

export default SeoBlock

